//import 'ol/ol.css';
import * as toastr from "toastr";
import {  FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as events from '../Bus/Bus';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter } from '../Activity/Activity';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

declare let moment: any; // Date helper from moment()

// Exports
export type infraConditionCallback = (result: Boolean, data: ICAMSKey, newIssueFlag: Boolean) => any;

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_InfraCondition {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();
    private unsatisfactoryConditions = [];
    
    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

       
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    
    public openConditionPanel = (data: ICAMSKey, infraConditionCode: string, callback: infraConditionCallback): void => {
        const self = this;
        let infraCode: string = data.code;

        let formUrl, submitUrl;
        formUrl = window.G_SITEFOLDERNAME + '/Infra/InfraConditionView';
        if (infraConditionCode == null) submitUrl = '/Infra/AddInfraCondition';
        else submitUrl = '/Infra/UpdateInfraCondition';

        // Get unsatisfactory conditions
        if (this.unsatisfactoryConditions.length == 0) this.getInfraConditionLUT();

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(formUrl, { infraCode: infraCode, infraConditionCode: infraConditionCode }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#infraConditionModal', ModalAction.Create);

            $('#infraConditionActivityBtn').on('click', function () { self.showActivityInPopover($(this), data, $('#infraConditionModal')); });

            // Create table
            ($('#infraAllConditionTable') as any).bootstrapTable();
            ($('#infraCondition_LinkedIssuesTable') as any).bootstrapTable();

            $('#infraCondition_LinkedIssuesTable [data-issueref]').on('click', function () {
                const linkdata: ICAMSKey = $(this).data("issueref");
                events.bus.publish(events.eventOpenMaintEditPanel(linkdata));
                Utilities.GetModal('#infraConditionModal', ModalAction.Hide);
            });

            // Get the WKT
            data.wkt = $('#infraConditionForm [name="WKT"]').val() as string;

            //initialise photo uploader
            self.photos.setupUploader('#infraConditionModal');

            // Get UDF's and conditional fields
            UserDefinedFields.ShowHideUDFs(<string>$('#infraConditionForm [name="InfraType"]').val(), $("#infraConditionForm"));

            // Get form validation
            Utilities.InitFormValidation($("#infraConditionForm"));

            $('#infraConditionSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                if (Utilities.CheckFormValidation($('#infraConditionForm')) == false) return;

                Utilities.BlockUI($("#infraConditionModal .modal-content"));
                let formData = new FormData(<any>$('#infraConditionForm')[0]);

                //check if condition is not satisfactory
                const condition = formData.get('Condition') as string;

                let suggestCreateMaint: boolean = self.unsatisfactoryConditions.find(f => f == condition)?.length == 1 ? true : false;

                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitUrl,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_AddedCondition" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); else toastr.info('Added condition!'); });
                                UserDefinedFields.SaveUDFFieldsAtServer($('#infraConditionForm'), '/Infra/UpdateInfraConditionUserFields', parseInt(result.code));
                                // Re-open the entity form
                                Utilities.GetModal('#infraConditionModal', ModalAction.Hide);

                                if (suggestCreateMaint) {
                                    //show a modal to ask if they want to create an Issue for the unsatifactory condition
                                    ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.InfraCondition_CreateIssue }).then(r => {
                                        if (r.yes == true) {
                                            callback(true, data, true);
                                        }
                                        else {
                                            callback(true, data, false);
                                        }
                                    }).catch(e => { });

                                }
                                else callback(true, data, false);
                            }
                            else {
                                toastr.error('Failed to add note!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            toastr.error('Failed to add note!');
                        }
                        finally {
                            Utilities.UnBlockUI($("#infraConditionModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#infraConditionCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#infraConditionModal', ModalAction.Hide);
                callback(false, { code: infraCode, featureType: FeatureType.Infra }, false);
            });

            $('#infraConditionCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#infraConditionModal', ModalAction.Hide);
                callback(false, { code: infraCode, featureType: FeatureType.Infra }, false);
            });

            $('#infraConditionDeleteBtn').on('click', function (evt) {
                data.uid = infraConditionCode as any;
                self.deleteCondition(data, callback);
            });
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    public deleteCondition = (data: ICAMSKey, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post(window.G_SITEFOLDERNAME + '/Infra/DeleteInfraCondition', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }

                    }
                    catch (err) {
                        console.log(err);
                    }
                    finally {
                        Utilities.GetModal('#infraConditionModal', ModalAction.Hide);
                        if (callback != null) callback(true, data, null);
                    };
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private showActivityInPopover = (el: JQuery<HTMLElement>, data: ICAMSKey, parentModal: JQuery<HTMLElement>): void => {
        let model: ActivityListRequestModel = { ID: data.code, ActivityListType: ActivityListType.InfraActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
        events.bus.publish(events.eventShowActivityList([el, model, parentModal]));
    }

    private getInfraConditionLUT = (): void => {
        var self = this;
        var url = window.G_SITEFOLDERNAME + '/LUT/GetSimpleLUT/';
        var query = { lutName: "InfraConditionLUT", getFullLUT: true };

        $.ajax({
            type: "POST",
            url: url,
            data: query,
            success: function (response) {
                try {
                    var result = response as Array<any>;
                    result.forEach(r => { if (r.isUnsatisfactory == true) self.unsatisfactoryConditions.push(r.infraCondition); });
                }
                catch (e) {
                    console.log("InfraCondition.getInfraConditionLUT: Error processing LUT", e);
                }
            },
            error: function (e) {
                console.log("InfraCondition.getInfraConditionLUT: Error getting LUT", e);
            }
        });
    }


}